import request from "@/router/axios";

// 新增巡检点
export const add = (row) => {
    return request({
        url: "/api/produce/inspection-point/insert",
        method: "post",
        data: row,
    });
};

// 更新巡检点
export const update = (row) => {
    return request({
        url: "/api/produce/inspection-point/update",
        method: "post",
        data: row,
    });
};

// 获取巡检点详情
export const getDetail = (id) => {
    return request({
        url: "/api/produce/inspection-point/select/id",
        method: "get",
        params: {
            id,
        },
    });
};

// 获取巡检点列表
export const getList = (data) => {
    return request({
        url: "/api/produce/inspection-point/select/page",
        method: "post",
        data,
    });
};

// 删除巡检点
export const remove = (ids) => {
    return request({
        url: "/api/produce/inspection-point/delete/ids",
        method: "get",
        params: {
            ids,
        },
    });
};

// 获取点位类型列表
export const getPointTypeList = () => {
    return request({
        url: "/api/inspection/point-type/select",
        method: "get",
    });
};

// 更新点位状态
export const updateStatus = (data) => {
    return request({
        url: "/api/produce/inspection-point/update/status/batch",
        method: "post",
        //   data::data,
        params: data
    });
};